import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  image = 'https://www.ashkeldalodge.com/images/hero-1.jpg',
  url
}) => {
  const siteTitle = 'Ashkelda Guest House';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Affordable Accommodation in Kwekwe, Zimbabwe`;
  const fullUrl = url ? `https://www.ashkeldalodge.com${url}` : 'https://www.ashkeldalodge.com';
  const finalDesc = description || 'Ashkelda Guest House – comfortable accommodation in Kwekwe, Zimbabwe. Rooms from $50/night. Free WiFi, DSTV, secure parking. Book via WhatsApp: 0781571761.';

  return (
    <Helmet>
      {/* Standard Meta */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;